import React, { Component } from 'react';

class Status extends Component {
  render() {
    return (
      <div>
        <div className={"usa-alert usa-alert-" + this.props.level}>
          <div className="usa-alert-body">
            <h3 className="usa-alert-heading">{this.props.heading}</h3>
            <p className="usa-alert-text">
              {this.props.body}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/Status.jsx